// extracted by mini-css-extract-plugin
export default {"pageFrame":"vELYfK","hasPaymentError":"lzIN8K","closePageButton":"oJR65w","goToSiteButton":"DPGSv3","closePageButtonIcon":"NFAfm_"};